export type MachineActionDisabledReason =
  | "client-missing"
  | "data-source-missing";

export interface MachineActionIdentity {
  connected_via_client?: string | null;
  missing_connected_via_client?: boolean;
  opc_ua_data_source_id?: string | null;
}

/** OPC UA actions require both a data source ID and a connected client ID. */
export const getMachineActionDisabledReason = (
  machine: MachineActionIdentity,
): MachineActionDisabledReason | undefined => {
  if (
    machine.missing_connected_via_client ||
    !machine.connected_via_client?.trim()
  ) {
    return "client-missing";
  }

  if (!machine.opc_ua_data_source_id?.trim()) {
    return "data-source-missing";
  }

  return undefined;
};
